import { DataRegistry } from './DataRegistry';
import { GameState } from '../game/GameState';
import type { EventChoiceData, EventData } from '../types/data';

export class EventManager {
  static readonly instance = new EventManager();

  pendingEvent?: EventData;

  maybeTriggerEvent() {
    const campaign = GameState.instance.requireCampaign();
    if (this.pendingEvent || campaign.turn % 3 !== 0) return undefined;
    const events = Object.values(DataRegistry.instance.events);
    if (!events.length) return undefined;
    const totalWeight = events.reduce((sum, event) => sum + Math.max(1, event.weight), 0);
    const roll = (campaign.turn * 23 + campaign.year) % totalWeight;
    let cursor = 0;
    for (const event of events) {
      cursor += Math.max(1, event.weight);
      if (roll < cursor) {
        this.pendingEvent = event;
        campaign.eventHistory.unshift({ id: event.id, title: event.title, turn: campaign.turn });
        campaign.eventHistory = campaign.eventHistory.slice(0, 20);
        GameState.instance.log(`Event: ${event.title}`, 'info');
        return event;
      }
    }
    return undefined;
  }

  choose(event: EventData, choice: EventChoiceData) {
    const campaign = GameState.instance.requireCampaign();
    const playerFaction = campaign.factions[campaign.playerFactionId];
    const selectedProvince = campaign.selectedProvinceId ? campaign.provinces[campaign.selectedProvinceId] : undefined;

    for (const [key, value] of Object.entries(choice.effects)) {
      if (typeof value !== 'number') continue;
      if (key === 'gold' || key === 'trade') playerFaction.treasury += value;
      else if (key === 'legitimacy') playerFaction.legitimacy = Math.max(0, Math.min(100, playerFaction.legitimacy + value));
      else if (key === 'prestige') playerFaction.prestige = Math.max(0, playerFaction.prestige + value);
      else if (selectedProvince) selectedProvince.storage[key] = (selectedProvince.storage[key] ?? 0) + value;
    }

    const historyEntry = campaign.eventHistory.find((entry) => entry.id === event.id && entry.turn === campaign.turn);
    if (historyEntry) historyEntry.choiceId = choice.id;
    this.pendingEvent = undefined;
    GameState.instance.log(`${event.title}: ${choice.label}`, 'success');
  }
}
